import styled from 'styled-components';

export const Wrapper = styled.div`
  > .MuiFormControl-root.MuiTextField-root {
    display: none;
  }
`;
